import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { aiApi } from '@wordpuppi/shared';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/account/ai-usage')({ component: AiUsagePage });

function AiUsagePage() {
  const { data, isLoading, error } = useQuery({ queryKey: ['ai-usage'], queryFn: () => aiApi.usage() });
  const month = data?.monthly;
  return <div className="space-y-6">
    <Card>
      <CardHeader>
        <CardTitle>AI usage</CardTitle>
        <CardDescription>Monthly Baxter token usage is counted per person across sites. Your own provider keys are metered here but do not spend the WordPuppi allowance.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2 text-sm">
        {isLoading ? <p>Loading usage…</p> : error ? <p role="alert">Could not load AI usage.</p> : month ? <>
          <p className="font-medium">{month.month}: {month.platform_tokens_used.toLocaleString()} of {month.platform_tokens_limit.toLocaleString()} platform tokens used or reserved</p>
          <p className="text-muted-foreground">{month.platform_tokens_remaining.toLocaleString()} remaining · {Math.max(0, data.limit - data.used)} of {data.limit} free tool calls remain separately.</p>
          {month.platform_budget_overrun && <p role="alert">Platform AI is paused for this month because a provider reported more tokens than reserved. Your own provider key remains available.</p>}
          {month.platform_budget_overrun && <p>Provider-reported platform tokens: {month.platform_tokens_provider_reported.toLocaleString()}</p>}
          <p>Your keys: {month.byok_tokens_reported.toLocaleString()} reported tokens · Known estimated cost: ${(month.known_estimated_cost_microusd / 1_000_000).toFixed(4)}</p>
          {month.incomplete_turns > 0 && <p className="text-muted-foreground">{month.incomplete_turns} turns have incomplete provider usage reports.</p>}
        </> : null}
      </CardContent>
    </Card>
    {month && <Card>
      <CardHeader><CardTitle>Recent turns</CardTitle><CardDescription>Up to 100 turns this month. Token counts come from each provider's response; cost is an estimate when a reliable rate is available.</CardDescription></CardHeader>
      <CardContent>
        {month.turns.length === 0 ? <p className="text-sm text-muted-foreground">No AI turns recorded this month.</p> :
          <div className="overflow-x-auto"><table className="w-full text-left text-sm">
            <thead><tr className="border-b"><th className="py-2 pr-4">Date</th><th className="py-2 pr-4">Model</th><th className="py-2 pr-4">Funding</th><th className="py-2 pr-4">Tokens</th><th className="py-2">Estimated cost</th></tr></thead>
            <tbody>{month.turns.map((turn) => <tr key={turn.turn_id} className="border-b last:border-0">
              <td className="py-2 pr-4 whitespace-nowrap">{new Date(turn.created_at * 1000).toLocaleString()}</td>
              <td className="py-2 pr-4">{turn.provider}:{turn.model}</td>
              <td className="py-2 pr-4">{turn.funding === 'platform' ? 'WordPuppi' : 'Your key'}</td>
              <td className="py-2 pr-4">{turn.usage_complete ? (turn.prompt_tokens + turn.completion_tokens).toLocaleString() : 'Incomplete report'}</td>
              <td className="py-2">{turn.estimated_cost_microusd === null ? 'Unknown' : `$${(turn.estimated_cost_microusd / 1_000_000).toFixed(4)}`}</td>
            </tr>)}</tbody>
          </table></div>}
      </CardContent>
    </Card>}
  </div>;
}
